import apiFetch from '../apiFetch'

export default function (token, documentVisualizationId) {
  return apiFetch({ endPoint: `DocumentVisualization/${documentVisualizationId}`, method: 'DELETE', body: null, token: token })
}
